import React from "react"
import { Check } from "lucide-react"

const Checkbox = React.forwardRef(({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
  const handleChange = (e) => {
    if (onCheckedChange) {
      onCheckedChange(e.target.checked);
    }
  };

  return (
    <div className="relative">
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={`
          h-4 w-4 rounded border-2 border-gray-300 bg-white 
          focus:ring-2 focus:ring-blue-500 focus:border-blue-500
          checked:bg-blue-600 checked:border-blue-600
          disabled:opacity-50 disabled:cursor-not-allowed
          ${className}
        `}
        {...props}
      />
      {checked && (
        <Check className="absolute inset-0 h-4 w-4 text-white pointer-events-none" />
      )}
    </div>
  );
});

Checkbox.displayName = "Checkbox"

export { Checkbox }